module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg7-80553f00ee7108d7b452b7014594058a.png";